export default function FaqData() {
    return [
        {
            title: "What is life insurance?",
            text: [
                "Life insurance is a financial planning tool that pays a lump sum benefit and typically pays tax-free to your designated beneficiary in the event of death. There are many variations in life insurance that can be customized to meet your needs."
            ]
        },
        {
            title: "What is decreasing term life insurance?",
            text: [
                "Decreasing term life insurance is designed to decrease in coverage amount over time in lock step with your mortgage or other personal or business loans."
            ]
        },
        {
            title: "What is term life insurance?",
            text: [
                "The \"term\" in term insurance refers to the period of time coverage remains in place at a fixed, level price. For example, a 30 year term would have the same coverage amount and annual price for all 30 years of protection. As long as premiums are paid each year, the full coverage will remain inforce."
            ]
        },
        {
            title: "What is the difference between term and permanent life insurance?",
            text: [
                "Term insurance is a lower cost insurance product designed to provide a level death benefit over a fixed period of time i.e. 10 to 30 years. Term insurance is an excellent option to provide protection for specific needs, i.e. a mortgage, college planning, as well as income replacement of the primary household income earner.",
                "Alternatively, permanent life insurance is designed to provide coverage over an entire lifetime, offering a combination of death benefit and tax deferred cash accumulation. Permanent insurance can be used to supplement long-term savings for retirement and offers other tax advantages."
            ]
        },
        {
            title: "Why purchase life insurance?",
            text: [
                "The reason someone purchases life insurance may vary. Purchase decisions range from tax planning to protecting your family financially in the event of an unexpected death. In most cases, life insurance is the best option to protect your family in the following ways:",
                [
                    "Providing for children or dependents",
                    "Income replacement",
                    "Funeral expenses",
                    "Education expense protection",
                    "Debt payoff",
                ]
             ]
        },
        {
            title: "Will my premiums increase during the term of coverage?",
            text: [
                "Term insurance premiums are guaranteed to remain level for the duration of guaranteed period. In addition, once your policy is approved, your life insurance coverage cannot be cancelled or changed, even if your health changes over time, provided premiums are paid as detailed in the policy.",
            ]
        },
        {
            title: "What are the premium rates based on?",
            text: [
                "Premiums are based on several different factors, including age, gender, tobacco use, and the term and amount of insurance coverage you choose."
            ]
        },
        {
            title: "When will my coverage begin?",
            text: [
                "Your coverage becomes effective after your application is approved and the carrier receives your first premium payment. Once your application is approved, you will also receive your policy which will include all terms and conditions of your coverage including beneficiaries, benefit amount and billing period for all subsequent premium payments.",
            ]
        },
        {
            title: "Is there the ability to cancel my policy after it is issued?",
            text: [
                "Yes, there are two ways in which you can cancel your policy. Within the first 10 to 30 days after issued (or according to your state regulations), you may cancel your policy and receive a refund of all premiums paid. This is referred as a “Free Look Period” that offers an unconditional money back guarantee. After the “Free Look Period,” for term life insurance, you may cancel your coverage at any time by no longer making premium payments. For permanent insurance, you may cancel your coverage by notifying the insurance company and receive any applicable cash accumulation payable to the owner according to the policy provisions.",
            ]
        },
        {
            title: "Can I add or change my beneficiary?",
            text: [
                "Yes, in most circumstances, the policy owner can change or add beneficiaries to the policy.",
            ]
        },
        {
            title: "What is the life insurance approval process?",
            text: [
                "Insurance companies have an \"underwriting process\" that evaluates the life insurance applicant on various criteria including:",
                [
                    "Applicant's current age, gender, tobacco use, height and weight, income and occupation",
                    "Applicant's lifestyle, hobbies and Health history (in addition to family health history of the applicant's parents and siblings)",
                    "The purpose of the insurance policy (estate planning, business, or individual life insurance) as well as existing life insurance already in place.",
                ],
                "All of the above factors are considered to be elements of risk. Each is analyzed and factored in by the life insurance company prior to a final decision."
            ]
        },
        {
            title: "What do I need to provide to the insurance company to complete the application process?",
            text: [
                "The process is simple for the applicant. First, the proposed insured needs to complete and sign the application with the insurance company. LoanMatch Protector is an instant decision self-directed product, so there is never a medical exam and the underwriting decision is made online in just a few minutes.",
            ]
        }
        ,{
            title: "How long does it take to get approved for life insurance coverage?",
            text: [
                "Depending on the applicant's age, amount of coverage and health history, the approval process can vary from as little as 15 minutes up to several weeks.  We can assist to determine the company and product that provides the fastest approval time for the applicant.",
            ]
        },
        {
            title: "After the applicant submits the application to the insurance company, what are the potential decisions the insurance company can make? ",
            text: [
                "One of four things will happen:",
                [
                    "Your coverage will be approved at the same rate for which you applied.",
                    "Your coverage will be approved at a less expensive rate than you applied.",
                    "Your coverage will be approved at a more expensive rate than you applied.",
                    "Your coverage will not be approved."
                ],
                "In the event that the coverage is approved at a higher rate, there are options, such as lowering the coverage amount and/or term,  so that the new rate stays within your budget.  In the event that coverage is not approved, we will work with you to review alternatives."
            ]
        },
        {
            title: "Why do I have to provide my email address?",
            text: [
                "As much of the process is internet based this application process requires that you enter your email address so that we can email you a link to e-sign your application.  You will also receive your policy electronically via email to print and file.",
            ]
        },
       
]}